import React from 'react';

import PropTypes from 'prop-types';

import { messages as modalMessages } from 'ui-components/components/modal/messages';
import { Text, TextType } from 'ui-components/components/text';
import { FlexColumn } from 'ui-components/components/flex';

import { SimpleModal } from '../../components/simple-modal';
import { messages } from './messages';

import style from './bulk-reship-modal.module.less';

export const BulkReshipModal = ({ fulfillmentPlanIds, onClose, show, onAction }) => {
  return (
    <SimpleModal
      actionMessage={messages.reshipButton}
      cancelMessage={modalMessages.modalCancel}
      headerMessage={messages.reshipModalHeader}
      onAction={onAction}
      onCancel={onClose}
      onClose={onClose}
      show={show}
      size='medium'
    >
      <FlexColumn className={style['bulk-reship-modal-content']}>
        <Text
          formattedMessageValues={{
            shipmentCount: fulfillmentPlanIds.length,
            b: (chunks) => <b>{chunks}</b>,
          }}
          textType={TextType.Paragraph}
          value={messages.bulkReshipSelectedShipments}
        />
        <ul className={style['bullet-list']}>
          <Text
            className={style['bullet-list-item']}
            element='li'
            textType={TextType.Paragraph}
            value={messages.bulkReshipImportedAsShippedInfo}
          />
          <Text className={style['bullet-list-item']} element='li' textType={TextType.Paragraph} value={messages.bulkReshipShipmentInfo} />
        </ul>
        <Text textType={TextType.Paragraph} value={messages.bulkReshipMarketplaceInfo} />
      </FlexColumn>
    </SimpleModal>
  );
};

BulkReshipModal.propTypes = {
  fulfillmentPlanIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  onAction: PropTypes.func.isRequired,
};
